module.exports = __webpack_public_path__ + "img/poster2.1897ba51.png";